'use client';
import React, { useState, useEffect } from 'react';
import { createClient } from '@/lib/supabase/client';
import { TrendingUp, Loader2 } from 'lucide-react';

interface TrendingTopic {
  tag: string;
  count: number;
}

export default function TrendingTopics() {
  const [topics, setTopics] = useState<TrendingTopic[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const supabase = createClient();
    supabase
      .from('posts')
      .select('tags')
      .eq('is_hidden', false)
      .not('tags', 'eq', '{}')
      .limit(100)
      .then(({ data }) => {
        if (!data) { setLoading(false); return; }
        const tagCounts: Record<string, number> = {};
        data.forEach((post: any) => {
          (post.tags || []).forEach((tag: string) => {
            tagCounts[tag] = (tagCounts[tag] || 0) + 1;
          });
        });
        const sorted = Object.entries(tagCounts)
          .sort(([, a], [, b]) => b - a)
          .slice(0, 8)
          .map(([tag, count]) => ({ tag, count }));
        setTopics(sorted);
        setLoading(false);
      });
  }, []);

  return (
    <div className="bg-white rounded-2xl border border-cream-300 p-5">
      <div className="flex items-center gap-2 mb-4">
        <TrendingUp size={15} className="text-gold-500" />
        <h3 className="text-sm font-semibold text-charcoal-900" style={{ fontFamily: "'Cinzel', serif" }}>Trending Topics</h3>
      </div>
      {loading ? (
        <div className="flex justify-center py-4">
          <Loader2 size={18} className="animate-spin text-charcoal-400" />
        </div>
      ) : topics.length === 0 ? (
        <p className="text-xs text-charcoal-400 text-center py-4">No trending topics yet.</p>
      ) : (
        <div className="flex flex-wrap gap-2">
          {topics.map(({ tag, count }) => (
            <span key={tag}
              className="px-3 py-1.5 bg-cream-100 border border-cream-300 rounded-full text-xs font-medium text-charcoal-700 hover:bg-cream-200 cursor-pointer transition-colors">
              {tag}
              <span className="ml-1 text-charcoal-400">({count})</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}